<template>
  <div
    v-if="
      whitelabel !== 'TD365' &&
      whitelabel !== 'TDSouthAfrica' &&
      whitelabel !== 'Blackstone' &&
      whitelabel !== 'OrbitInvest'
    "
    class="language-switcher-vue"
  >
    <div class="language-switcher-wrapper space-y-1 rounded-md shadow-lg">
      <div class="relative rounded-md">
        <span :class="bottom ? 'rounded-top' : ''" class="inline-block w-full">
          <button
            :class="
              showMenu
                ? 'rounded-b-md bg-white switcher-open'
                : 'rounded-md bg-customize text-white'
            "
            aria-expanded="true"
            aria-haspopup="listbox"
            aria-labelledby="listbox-label"
            class="cursor-pointer relative w-full pl-3 pr-10 py-2 text-left focus:outline-none focus:none focus:border-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            type="button"
            @click="showMenu = !showMenu"
          >
            <span
              :class="showMenu ? 'text-gray-500' : 'text-white'"
              class="flex truncate"
            >
              <svg
                class="my-auto me-2"
                fill="none"
                height="15"
                viewBox="0 0 14 15"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.78125 0.96875C3.03516 0.96875 0 4.00391 0 7.75C0 11.4961 3.03516 14.5312 6.78125 14.5312C10.5273 14.5312 13.5625 11.4961 13.5625 7.75C13.5625 4.00391 10.5273 0.96875 6.78125 0.96875ZM5.90625 2.36328V2.69141C5.90625 2.99219 5.55078 3.21094 5.25 3.07422L4.59375 2.74609C5.00391 2.55469 5.44141 2.44531 5.90625 2.36328ZM6.78125 12.4805V13.2188C3.74609 13.2188 1.3125 10.7852 1.3125 7.75C1.3125 6.95703 1.47656 6.21875 1.77734 5.53516C2.05078 5.91797 2.46094 6.54688 2.73438 6.92969C2.87109 7.12109 3.03516 7.3125 3.22656 7.50391H3.25391C3.5 7.75 3.80078 7.94141 4.10156 8.10547C4.48438 8.29688 5.05859 8.59766 5.44141 8.81641C5.71484 8.98047 5.90625 9.25391 5.90625 9.58203V10.457C5.90625 10.7031 5.98828 10.9219 6.15234 11.0859C6.5625 11.4961 6.80859 12.125 6.78125 12.4805ZM7.92969 13.1094L8.42188 11.8242C8.47656 11.6602 8.50391 11.5234 8.53125 11.3594C8.58594 11.25 8.64062 11.1406 8.72266 11.0586L9.02344 10.7578C9.26953 10.5117 9.40625 10.1836 9.40625 9.85547C9.40625 9.63672 9.29688 9.41797 9.16016 9.25391L8.77734 8.89844C8.61328 8.73438 8.39453 8.625 8.14844 8.625H6.34375C6.07031 8.51562 5.74219 7.75 5.46875 7.75C5.16797 7.75 4.89453 7.69531 4.62109 7.55859L4.32031 7.42188C4.21094 7.36719 4.15625 7.23047 4.15625 7.12109C4.15625 6.98438 4.23828 6.84766 4.375 6.82031L5.22266 6.51953C5.35938 6.46484 5.52344 6.51953 5.63281 6.60156L5.90625 6.82031C5.93359 6.875 5.98828 6.875 6.04297 6.875H6.20703C6.37109 6.875 6.45312 6.71094 6.39844 6.57422L5.96094 5.72656C5.93359 5.61719 5.93359 5.53516 6.01562 5.45312L6.28906 5.20703C6.31641 5.15234 6.37109 5.125 6.42578 5.125H6.67188C6.72656 5.125 6.78125 5.125 6.83594 5.07031L7.05469 4.85156C7.13672 4.76953 7.13672 4.63281 7.05469 4.55078L6.91797 4.41406C6.83594 4.33203 6.83594 4.19531 6.91797 4.11328L7.21875 3.8125L7.32812 3.70312C7.49219 3.53906 7.49219 3.23828 7.32812 3.07422L6.5625 2.30859C6.61719 2.30859 6.69922 2.28125 6.78125 2.28125C8.91406 2.28125 10.7461 3.53906 11.6484 5.31641L11.293 5.50781C11.2109 5.5625 11.1016 5.61719 11.0469 5.72656L10.5 6.51953C10.3633 6.73828 10.3633 7.03906 10.5 7.25781L10.9922 7.99609C11.1016 8.13281 11.2383 8.21484 11.4023 8.26953L12.1953 8.46094C11.8945 10.7578 10.1719 12.6172 7.92969 13.1094Z"
                  fill="#889AB6"
                />
              </svg>
              {{ languages[selected] }}
            </span>
            <span
              class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
            >
              <svg
                class="h-5 w-5 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
              </svg>
            </span>
          </button>
        </span>

        <div
          v-if="showMenu"
          :class="bottom ? 'z-10 bg-white' : 'bottom-9 bg-white rounded-t-md'"
          class="absolute w-full pt-1 overflow-scroll language-switcher-content"
        >
          <ul
            aria-labelledby="listbox-label"
            class="max-h-60 text-base leading-6 sm:text-sm sm: focus:outline-none focus:border-none"
            role="listbox"
            tabindex="-1"
          >
            <li
              v-for="(local, index) in lang"
              id="listbox-option-0"
              :key="index"
              class="text-gray-500 cursor-default select-none relative py-1 pl-3 pr-3 rounded-md cursor-pointer"
              role="option"
              @click="
                changeLanguage(local), (selected = local), (showMenu = false)
              "
            >
              <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
              <span class="font-normal block truncate">
                {{ languages[local] }}
              </span>
              <hr class="mt-3 w-100" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueI18Next from "@panter/vue-i18next";
import i18next from "i18next";
import { languageOptions } from "@/views/choices";

const i18n = new VueI18Next(i18next);
export default {
  name: "LanguageSwitcher",
  data() {
    return {
      selected: localStorage.getItem("lang") || "en",
      showMenu: false,
      lang: languageOptions(),
      whitelabel: process.env.VUE_APP_WHITELABEL,
    };
  },
  props: {
    bottom: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
  },
  computed: {
    languages() {
      const t = this.$t.bind(this);
      if (this.whitelabel === "VCGMarkets") {
        return {
          en: t("English"),
          ar: t("Arabic"),
          ku: t("Kurdish"),
        };
      }

      return {
        en: t("English"),
        ar: t("Arabic"),
        fa: t("Persian"),
        "zh-Hans": t("chinese-simplified"),
        "zh-Hant": t("chinese-traditional"),
        nl: t("Dutch"),
        ru: t("Russian"),
        es: t("Spanish"),
        id: t("Indonesian"),
        ms: t("Malay"),
        vi: t("Vietnamese"),
        pt: t("Portuguese"),
        de: t("German"),
        th: t("Thai"),
        ko: t("Korean"),
      };
    },
  },
  created() {
    let lang = localStorage.getItem("lang") || "en";
    this.$i18n.i18next.changeLanguage(lang);
  },
  methods: {
    changeLanguage(lang) {
      localStorage.setItem("lang", lang);
      this.$store.commit("CHANGE_LANGUAGE", lang);
      this.$i18n.i18next.changeLanguage(lang);
      if (lang === "ar" || lang === "fa") {
        document.getElementById("body").dir = "rtl";
      } else {
        document.getElementById("body").dir = "ltr";
      }
    },
  },
};
</script>
